import ApiNode from "./ApiNode";
import ApiPhp from "./Api";

export default {
  multiUpdateAirAssignment(payload) {
    return ApiNode().post("air/multi-update", payload);
  },

  getAssignmentDetails(payload) {
    return ApiPhp().post(
      "Api_Common/viewAssignmentMultiUpdateDetails.php",
      payload,
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/AirExpImpService.js